import {Constants} from "../constants";
import {Routes} from "@angular/router";
import {UserRolesGuard} from "../route-guards/user-roles.guard";
import {HighConversionPageComponent} from "./hcp/high-conversion-page.component";
import {PageNotFoundComponent} from "./page-not-found/page-not-found.component";
import {PageEmbedComponent} from "./embed/page-embed.component";

export const MARKETING_PAGE_ROUTES: Routes = [
    {

        path: ':locale/' + Constants.MARKETING_PAGE_STATE,
        canActivateChild: [UserRolesGuard],
        data: {
            roles: [Constants.ROLES.ANY]
        },
        children: [
            {
                path: Constants.MARKETING_PAGE_NOT_FOUND_STATE,
                component: PageNotFoundComponent,
                data: {
                    roles: [Constants.ROLES.ANY]
                }
            },
            {
                //queryParam option: {country: string, date: string, preview: boolean}
                path: ':uniqueId',
                component: HighConversionPageComponent,
                data: {
                    roles: [Constants.ROLES.ANY],
                    restrict: [Constants.ROLES.NFR, Constants.ROLES.NFR_MHP_ONLY, Constants.ROLES.CBEC]
                }
            }
        ]
    },
    {

        path: ':locale/' + Constants.MARKETING_PAGE_EMBED_STATE,
        canActivateChild: [UserRolesGuard],
        data: {
            roles: [Constants.ROLES.ANY]
        },
        children: [
            {
                path: Constants.MARKETING_PAGE_NOT_FOUND_STATE,
                component: PageNotFoundComponent,
                data: {
                    roles: [Constants.ROLES.ANY]
                }
            },
            {
                path: ':uniqueId',
                component: PageEmbedComponent,
                data: {
                    roles: [Constants.ROLES.ANY],
                    restrict: [Constants.ROLES.NFR, Constants.ROLES.NFR_MHP_ONLY, Constants.ROLES.CBEC]
                }
            }
        ]
    }
];
